enum FsaFormSteps {
  User,
  FSA,
  Claim,
  Review,
  FinalReview,
}

export default FsaFormSteps;
